import { render, staticRenderFns } from "./spareGetList.vue?vue&type=template&id=bcd153ac&scoped=true"
import script from "./spareGetList.vue?vue&type=script&lang=js"
export * from "./spareGetList.vue?vue&type=script&lang=js"
import style0 from "./spareGetList.vue?vue&type=style&index=0&id=bcd153ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd153ac",
  null
  
)

export default component.exports